import { CreditCardInfo } from '@app/core/models/openpay.model';
import {
  ICreditCard,
  IPaymentParams,
  ICreatePaymentResponse,
  IRequestPaymentResponse,
  IRequestPaymentParams,
} from '@app/core/models/payments.model';
import { createAction, props } from '@ngrx/store';

export const getCreditCardType = createAction(
  '[Payment Effecrs] Get Credit Card Type',
  props<{ creditCardInfo: CreditCardInfo }>()
);

export const failureGetCreditCardType = createAction(
  '[Payment Effects] Failure Get Credit Card Type',
  props<{ error: string }>()
);

export const setDebitCardFlag = createAction(
  '[Payments Effects] Set isDebitCard Flag',
  props<{ isDebitCard: boolean }>()
);

export const createCardToken = createAction(
  '[Payment Facade] Create Card Token',
  props<{ creditCardInfo: CreditCardInfo; paymentParams: IPaymentParams }>()
);

export const successCreateCardToken = createAction(
  '[Payment Effects] Success Create Card Token',
  props<{ creditCard: ICreditCard }>()
);

export const failureCreateCardToken = createAction(
  '[Payment Effects] Failure Create Card Token',
  props<{ error: string }>()
);

export const createCreditCard = createAction('[Payment Effecrs] Create Credit Card');

export const successCreateCreditCard = createAction('[Payment Effects] Success Create Credit Card');

export const failureCreateCreditCard = createAction(
  '[Payment Effects] Failure Create Credit Card',
  props<{ error: string }>()
);

//TODO: define si esto debe o no tener la info
export const createPayments = createAction('[Payment Facade] Create Payment');

export const successCreatePayments = createAction(
  '[Payment Effects] Success Create Payment',
  props<{ requestPaymentParams: IRequestPaymentParams }>()
);

export const failureCreatePayments = createAction(
  '[Payment Effects] Failure  Create Payment',
  props<{ error: string }>()
);

export const requestPayment = createAction(
  '[Payment Facade] Request Payment',
  props<{ requestPaymentParams: IRequestPaymentParams }>()
);

export const successRequestPayment = createAction('[Payment Effects] Success Request Payment');

export const failureRequestPayment = createAction(
  '[Payment Effects] Failure Request Payment',
  props<{ error: string }>()
);

export const setRequestPaymentParams = createAction(
  '[Payments] Set Request Payment Params',
  props<{ requestPaymentParams: IRequestPaymentParams }>()
);

export const setRequestPaymentResponse = createAction(
  '[Payments] Set Request Payment Response',
  props<{ requestPaymentResponse: IRequestPaymentResponse }>()
);

export const open3dsRedirection = createAction(
  '[Payments] Open 3ds Redirection',
  props<{ requestPaymentResponse: IRequestPaymentResponse }>()
);

export const successOpen3dsRedirection = createAction(
  '[Payments] Success Open 3ds Redirection',
  props<{
    requestPaymentParams: IRequestPaymentParams;
  }>()
);

export const failureOpen3dsRedirection = createAction(
  '[Payments] Failure Open 3ds Redirection',
  props<{ error: string }>()
);

export const redirectToPaymentStatus = createAction('[Payments] Redirect to Payment Status');

export const createPaymentIfHasCard = createAction(
  '[Payment Facade] Create Payment If Has Card',
  props<{ paymentParams: IPaymentParams }>()
);

export const setDeviceSessionId = createAction(
  '[Payment Effects] Set Device Session ID',
  props<{ deviceSessionId: string }>()
);

export const setPaymentsParams = createAction(
  '[Payments] Set Payments Params',
  props<{ paymentParams: IPaymentParams }>()
);

export const redirectToMerchant = createAction('[Payments] Redirect to Merchant Page');

export const redirectToMerchantWithLoop = createAction('[Payments] Redirect to Merchant With Loop');

export const redirecToPersonalInfo = createAction('[Payments] Redirect to Personal Info');

export const setIsLoadingPayment = createAction(
  '[Payments] Set True or False isLoadingPayments',
  props<{ isLoading: boolean; step?: number }>()
);

export const setPaymentErrorCode = createAction('[Payments] Set Payment Error Code');

export const setLoading = createAction(
  '[Payments] Set Loading Payment',
  props<{ isLoadingPayments: boolean }>()
);

export const setCreditCardInfo = createAction(
  '[Payments] Set Credit Card Info',
  props<{ creditCardInfo: CreditCardInfo }>()
);

export const setPaymentParams = createAction(
  '[Payments] Set Payment Params',
  props<{ paymentParams: IPaymentParams }>()
);
